import React, { useContext, useEffect } from "react";
import "./style.css";
import axios from "axios";
import moment from "moment";
import { Markup } from "interweave";
import { useState } from "react";
import Navigation from "../../Layouts/Header/Navigation";
import { Card } from "react-bootstrap";
import { CardContent } from "@material-ui/core";
import RegisterNowPay from "../../../components/RegisterLearningDetails/RegisterNowPay/RegisterNowPay";
import swal from "sweetalert";

import QnADetailsSkeliton from "./QnADetailsSkeliton";
import { LocationContext } from "../../../CustomHelper/Helper";
import { serverInfo } from "../../../App";

const QnaDetails = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const { paymentCount, paymentCountWithSymbol, payStatus } =
    useContext(LocationContext);

  const [LoadingQnaDetails, setLoadingQnaDetails] = useState([]);
  const [loader, setLoader] = useState(false);

  const [post, setPost] = useState({});

  // Live Fee Determination
  const [minuteInput, setMinuteInput] = useState(null);
  const [minuteError, setMinuteError] = useState();
  const [feeCount, setFeeCount] = useState(0);
  const [startTime, setStartTime] = useState();
  const [endTime, setEndTime] = useState();
  const [slotAvailable, setSlotAvailable] = useState(false);

  useEffect(() => {
    const event_id = props.match.params.slug;

    axios.get(`/api/user/qna/${event_id}`).then((res) => {
      if (res.data.status === 200) {
        setLoadingQnaDetails(false);
        setPost(res.data.event);
        // setFeeCount(res.data.event?.fee);
      }
    });
  }, [props.match.params.slug]);

  //form validation
  const validateFormData = () => {
    if (
      minuteInput !== "" &&
      minuteInput <= Number(post.max_time) &&
      minuteInput >= Number(post.min_time)
    ) {
      axios.get("/sanctum/csrf-cookie").then((response) => {
        axios
          .get(`/api/user/getSingleQnaEvent/${minuteInput}/${post.id}`)
          .then((res) => {
            if (res.data.status === 200) {
              if (res.data.available === true) {
                swal("success", res.data.message, "success");
                setStartTime(res.data.start_time);
                setEndTime(res.data.end_time);
                setMinuteError("");
                setSlotAvailable(true);
              } else {
                swal("warning", res.data.message, "warning");
                setMinuteError("");
              }
            }
          });
      });
    } else {
      if (minuteInput == null) {
        setMinuteError("Insert a minute !");
      } else if (minuteInput < Number(post.max_time)) {
        setMinuteError(`Select maximum ${Number(post.max_time)} minute !`);
      } else if (minuteInput > Number(post.min_time)) {
        setMinuteError(`Select Less than ${Number(post.max_time)} minute !`);
      } else {
        setMinuteError("");
      }
    }
  };

  const getFeeCount = (e) => {
    let minute = e.target.value;

    if (minute < Number(post.min_time)) {
      setMinuteError(`Select minimum ${Number(post.min_time)} minute !`);
    } else if (minute > Number(post.max_time)) {
      setMinuteError(`Select Less than ${Number(post.max_time)} minute !`);
    } else {
      setMinuteError("");
    }

    setMinuteInput(minute);

    if (minute <= 0) {
      setFeeCount(paymentCount(post?.fee));
    } else {
      setFeeCount(paymentCount(post?.fee) * minute);
    }
  };

  return (
    <>
      <Navigation />
      {LoadingQnaDetails ? (
        <QnADetailsSkeliton />
      ) : (
        <div className="container">
          <div className="mt-3 d-flex justify-content-center card-bg1 p-2 card">
            <img
              src={imageCdnUrl + post.banner}
              className="img-fluid w-100"
              alt={imageCdnUrl + post.banner}
            />
          </div>

          <div className="row mt-3">
            <div className="col-md-12">
              <div className="card card-bg1 shadow p-3">
                <div className="card-body">
                  <h5 className="text-light pb-3">{post.title}</h5>

                  <h5 className="text-warning">Instruction</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={post.instruction} />
                  </p>

                  <h5 className="text-warning">Description</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={post.description} />
                  </p>

                  <div className="row">
                    <div className="col-md-3  ">
                      <div className="card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                        <h5 className="text-warning pt-2 ">Star Name</h5>
                        <p className="text-light fw-bold pt-2">
                          {post.star?.first_name} {post.star?.last_name}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 ">
                      <div className="card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                        <h5 className="text-warning pt-2 ">Event Date</h5>
                        <p className="text-light fw-bold pt-2">
                          {moment(post.event_date).format("LL")}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 ">
                      <div className="card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                        <h5 className="text-warning pt-2 ">Time</h5>
                        <p className="text-light fw-bold pt-2">
                          {moment(post.start_time, "HH:mm:ss").format(
                            "hh:mm A"
                          )}{" "}
                          -{" "}
                          {moment(post.end_time, "HH:mm:ss").format("hh:mm A")}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-3 ">
                      <div className="card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                        <h5 className="text-warning pt-2 ">Fee</h5>
                        <p className="text-light fw-bold pt-2">
                          {paymentCountWithSymbol(post?.fee)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Card
            className="my-4"
            style={{ backgroundColor: "#25272b" }}
            sx={{ minWidth: 275 }}
          >
            <CardContent>
              {!slotAvailable ? (
                <div className="guitarBorder">
                  <div className="card-body">
                    <h5 className="card-title text-warning">Slot checking</h5>
                    <div className="star-line"></div>
                    <div className="card-body">
                      <div className="row mt-3">
                        <div className="col-6 ">
                          <h6 className="text-light">Time PeriodTime</h6>
                          <div className="left-slot  w-75 text-center p-1">
                            <input
                              type="number"
                              placeholder={`Enter Time Between ${Number(
                                post.min_time
                              )} - ${Number(post.max_time)}`}
                              name="minute"
                              value={minuteInput}
                              onChange={getFeeCount}
                              className="form-control time"
                            ></input>
                          </div>
                          <p className="text-warning">{minuteError}</p>
                        </div>

                        <div className="col-6 ">
                          <h6 className="text-light">Total Cost</h6>
                          <div className="left-slot  w-75 text-center p-1">
                            <input
                              type="text"
                              value={minuteInput ? feeCount : 0}
                              readOnly
                              text-center
                              placeholder="amount"
                              className="form-control time"
                              disabled
                            ></input>
                          </div>
                        </div>
                      </div>
                    </div>
                    {payStatus && (
                      <center>
                        <div
                          className="Right-slot slot-btn bg-warning  w-25 text-center p-1"
                          onClick={validateFormData}
                        >
                          <span className="text-dark">
                            {loader && (
                              <>
                                <i className="fas fa-spinner fa-pulse"></i>
                                &nbsp;
                              </>
                            )}
                            Check Slot
                          </span>
                        </div>
                      </center>
                    )}
                  </div>
                </div>
              ) : (
                <RegisterNowPay
                  post={post}
                  event_type="qna"
                  quantity={minuteInput}
                  baseFee={post.fee}
                  fee={feeCount}
                  start_time={startTime}
                  end_time={endTime}
                />
              )}
            </CardContent>
          </Card>
        </div>
      )}
    </>
  );
};

export default QnaDetails;
